import React from "react";
import { Link, useParams } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

export default function ProviderBookingDetailPage() {
  const { bookingId } = useParams();

  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>
          Booking detail {bookingId ? `· ${bookingId}` : ""}
        </h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Inspect booking status, assigned stylist, customer notes, payment mode, and operational actions.
        </p>
      </section>

      <section style={cardStyle}>
        <div style={{ display: "grid", gap: "0.7rem", color: "#334155" }}>
          <div><strong>Customer:</strong> Demo customer</div>
          <div><strong>Service:</strong> Demo service</div>
          <div><strong>Status:</strong> ACCEPTED</div>
          <div><strong>Stylist:</strong> Assigned stylist</div>
          <div><strong>Payment mode:</strong> Deposit online, remainder in-store</div>
          <div><strong>Operational note:</strong> Arrive 10 minutes early.</div>
        </div>
      </section>

      <section style={cardStyle}>
        <Link
          to="/provider/dashboard/bookings"
          style={{
            textDecoration: "none",
            border: "1px solid #d1d5db",
            borderRadius: 12,
            padding: "0.75rem 1rem",
            color: "#111827",
            fontWeight: 700,
            display: "inline-flex",
          }}
        >
          Back to bookings
        </Link>
      </section>
    </div>
  );
}